import { atom } from "jotai";
import { ReportingPeriod } from "@/types/ReportingPeriod";

/**
 * Jotai atom for storing the list of all reporting periods.
 * Manages the collection of ReportingPeriod objects available in the application.
 * Initial state is an empty array.
 */
export const ReportingPeriodAtom = atom<ReportingPeriod[]>([]);

/**
 * Jotai atom for storing the currently selected reporting period.
 * Used to track which reporting period is currently being viewed or edited.
 * Initial state is undefined (no reporting period selected).
 */
export const SelectedReportingPeriodAtom = atom<ReportingPeriod | undefined>(
  undefined
);
